// 过滤器
export default {
    // 登录保存用户信息
    saveUser: function (da) {
        if ((da.code === '200' || da.code === 200) && da.result) {
            localStorage.setItem('user', JSON.stringify(da.result.user))
            if (da.result.token) {
                localStorage.setItem('token', da.result.token)
            }
            if (da.result.permissionCode) {
                localStorage.setItem('permissionCodeList', da.result.permissionCode)
            }
        }
        return da
    },
    // 登出
    loginOut: function (da) {
    // 清理掉登录信息
        if (da.code === '200' || da.code === 200) {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            localStorage.removeItem('permissionCodeList')
            const keyParams = localStorage.getItem('keyParams')
            if (keyParams) {
                window.location.href = location.protocol + '//' + location.host + '/login.html#/?appId=' + keyParams
                localStorage.removeItem('keyParams')
                return false
            }
            window.location.href = location.protocol + '//' + location.host + '/login.html#/'

            location.reload()
        } else {
            console.log(da)
            console.log('登出失败;')
        }
        return da
    },
    // 登录状态
    loginStatus: function (da) {
        if ((da.code === '200' || da.code === 200) && da.result) {
            console.log(da.result)
        } else {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            localStorage.removeItem('permissionCodeList')
            localStorage.removeItem('keyParams')
        }
        return da
    }
}
